import { createStore, applyMiddleware, Store } from 'redux'
import thunk from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'
import { rootReducer, RootState } from './rootReducer'
import { ActionTypes, DispatchType } from './User/types'

function saveToLocalStorage(state: RootState) {
  try {
    const serialisedState = JSON.stringify(state)
    localStorage.setItem('persistantState', serialisedState)
  } catch (e) {
    console.warn(e)
  }
}

function loadFromLocalStorage() {
  try {
    const serialisedState = localStorage.getItem('persistantState')
    if (serialisedState === null) return undefined
    return JSON.parse(serialisedState)
  } catch (e) {
    console.warn(e)
    return undefined
  }
}

const store: Store<RootState, ActionTypes> & {
  dispatch: DispatchType
} = createStore(rootReducer, loadFromLocalStorage(), composeWithDevTools(applyMiddleware(thunk)))

store.subscribe(() => saveToLocalStorage(store.getState()))

export default store
